import { useState } from "react";
import { AlertTriangle, Trash2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "@/components/Toast";

const CONFIRM_WORD = "BORRAR";

/** Botón + modal para vaciar (DELETE masivo) un historial de registros,
 * con confirmación escrita y filtro opcional por objetivo. Reutilizado por
 * Vehículos y Visitas (admin/supervisor). */
export function ClearLogsButton({ endpoint, clients, label, onDone, testidPrefix }) {
  const [open, setOpen] = useState(false);
  const [clientId, setClientId] = useState("");
  const [confirmText, setConfirmText] = useState("");
  const [busy, setBusy] = useState(false);
  const matches = confirmText.trim().toUpperCase() === CONFIRM_WORD;

  const close = () => { setOpen(false); setClientId(""); setConfirmText(""); };

  const submit = async (e) => {
    e.preventDefault();
    if (!matches) return;
    setBusy(true);
    try {
      const { data } = await api.delete(endpoint, { params: clientId ? { client_id: clientId } : {} });
      toast.success(`Se eliminaron ${data.deleted} registro(s) de ${label}`);
      close();
      onDone?.();
    } catch (e2) { toast.error(formatApiError(e2)); }
    finally { setBusy(false); }
  };

  return (
    <>
      <button type="button" className="btn-ghost" onClick={() => setOpen(true)}
        style={{ color: "#BF3437", borderColor: "#BF3437", display: "inline-flex", alignItems: "center", gap: 6 }}
        data-testid={`${testidPrefix}-clear-open`}>
        <Trash2 size={13} /> Vaciar historial
      </button>

      {open && (
        <div className="modal-overlay" onClick={close} data-testid={`${testidPrefix}-clear-modal`}>
          <form className="modal" onClick={(e) => e.stopPropagation()} onSubmit={submit}>
            <h3 style={{ color: "#BF3437", display: "flex", alignItems: "center", gap: 8 }}>
              <AlertTriangle size={18} /> Vaciar historial de {label}
            </h3>
            <p style={{ fontSize: 13 }}>
              Esta acción es <b>irreversible</b>. Elegí qué querés borrar:
            </p>
            <div className="field">
              <label>Objetivo</label>
              <select value={clientId} onChange={(e) => setClientId(e.target.value)} data-testid={`${testidPrefix}-clear-client`}>
                <option value="">Todos los objetivos</option>
                {clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>
            <div className="field">
              <label>Para confirmar, escribí <b>{CONFIRM_WORD}</b></label>
              <input value={confirmText} onChange={(e) => setConfirmText(e.target.value)} autoFocus data-testid={`${testidPrefix}-clear-confirm-input`} />
            </div>
            <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
              <button type="button" className="btn-ghost" onClick={close}>Cancelar</button>
              <button type="submit" className="btn-primary" style={{ background: "#BF3437" }}
                disabled={busy || !matches} data-testid={`${testidPrefix}-clear-confirm-submit`}>
                {busy ? "Borrando..." : "Vaciar historial"}
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}
